/**
 * NBConvert cells do not have built in overflow detection. This script adds
 * tabbable behavior to cells that have horizontal overflow.
 */

export function initializeCellAccessibility(notebookContainer: HTMLElement) {
  resizeObserver.observe(notebookContainer)
}

const resizeObserver = new ResizeObserver(entries => {
  for (const entry of entries) {
    makeCellsTabbable(entry.target)
  }
})

const makeCellsTabbable = (el: Element) => {
  const cells = el.querySelectorAll('.jp-Editor')
  for (const cell of cells) {
    if (cell.scrollWidth > cell.clientWidth) {
      if (cell.getAttribute('tabindex') === null) {
        cell.setAttribute('tabindex', '0')
      }
    } else {
      cell.removeAttribute('tabindex')
    }
  }
}
